import React, { Component } from 'react';
import { Field } from 'redux-form';
import { Grid, Row, Col, Panel, Button, ButtonToolbar, Breadcrumb } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../components/Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import { numberWithCommas } from '../Common/numberWithCommas';
import { Selection } from '../Common/selection';
import { UI_HEIGHT } from '../Common/constants';
import RowLabelField from '../Common/RowLabelField';
import { getFromToDates, dateFormat, toFromDates } from '../Common/cleanDates';
import VendorStatementDetailTable from './VendorStatement/vendorStatementDetailTable';
import { ROOT_URL, companyCodeTitle, isOLG, isLAP, isGGI } from '../../actions/root_url';
import checkPermission from '../Common/permissions';
import PrintIframe from '../Common/PrintIframe';
import GenericSelection from '../Common/GenericSelection';
import GenericDatePicker from '../Common/GenericDatePicker';
import genericRadioFilter from '../Common/genericRadioFilter';
import { getLocalStorageData } from '../../reducers/headerRedux'

momentLocalizer(moment);

const getBsStyle = (input, value) => (input === value ? 'success' : 'primary');

class VendorStatement extends Component {
  static getQuarter() {
    return Math.ceil((new Date().getMonth() + 1) / 3);
  }
  constructor() {
    super();
    this.state = {
      tableHeight: window.innerHeight - UI_HEIGHT.vendorsPage - 100,
      statementLines: [],
      // filteredLines: [],
      invoiceAmount: 0,
      paymentAmount: 0,
      totalBalance: 0,
      remainBalance: 0,
      previousBalance: 0,
      pdfFrameLoaded: true,
      pdfFrameWarehouseLoaded: true,
      // yearChanged: false,
      // invoiceFilter: 'all',
      fromDate: (isOLG || isLAP) ? new Date(moment().subtract(7, 'd').toISOString()) : new Date('2017-08-18T00:00:00-0700'),
      toDate: new Date(),
      paymentCutoffDate: new Date(),
      typeRadios: 'range',
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      quarter: VendorStatement.getQuarter(),
    };

    this.setMonthSelected = this.setMonthSelected.bind(this);
    this.setQuarterSelected = this.setQuarterSelected.bind(this);
    this.handleDateFilterChange = this.handleDateFilterChange.bind(this);
    this.setFromDate = this.setFromDate.bind(this);
    this.setToDate = this.setToDate.bind(this);
    this.setPaymentCutoffDate = this.setPaymentCutoffDate.bind(this);
  }

  componentWillMount() {
    const { currentVendor } = this.props;
    this.props.fetchVendors(checkPermission('vendors_manager') ? {Company_id: undefined} : {});
    if (currentVendor) {
      this.props.setValue('vendorStatement', 'Vendor', { value: currentVendor.vendor_id });
    }
  }

  componentDidMount() {
    document.title = companyCodeTitle;
    window.addEventListener('resize', this.handleResize);
    // this.props.setDefaultOfForm('typeRadios', 'range', 'vendorStatement');
    // this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'vendorStatement');
    // this.props.setDefaultOfForm('ToDate', new Date(), 'vendorStatement');
    // this.props.setDefaultOfForm('StatementType', 'forwarded', 'vendorStatement');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.vendorStatement && nextProps.vendorStatement !== this.props.vendorStatement) {
      const statementLines = nextProps.vendorStatement.ap_payment_lines;
      const invoiceAmount = nextProps.vendorStatement.invoice_amount;
      const paymentAmount = nextProps.vendorStatement.payment_amount;
      const totalBalance = nextProps.vendorStatement.total_balance;
      const remainingBalance = nextProps.vendorStatement.remaining_balance;
      const forwardedBalance = nextProps.vendorStatement.forwarded_amount;
      // let remainBalance = nextProps.vendorStatement.RemainingBalance;
      // let previousBalance = 0;
      // if (this.props.StatementType === 'forwarded') {
      //   previousBalance = nextProps.vendorStatement.PreviousBalance;
      //   remainBalance += previousBalance;
      // }
      // let filteredLines;
      // const { invoiceFilter } = this.state;
      // if (invoiceFilter !== 'all') {
      //   filteredLines = statementLines.filter(line => line.type === invoiceFilter);
      // } else {
      //   filteredLines = statementLines;
      // }
      this.setState({
        statementLines,
        // filteredLines,
        invoiceAmount,
        paymentAmount,
        totalBalance,
        remainingBalance,
        forwardedBalance,
      });
    }
    // if (nextProps.StatementType && nextProps.StatementType !== this.props.StatementType) {
    //   let year = '';
    //   let month = '';
    //   let quarter = '';
    //   let date = -1;
    //   const fromDate = this.props.FromDate ? formatDate(this.props.FromDate) : '1900-01-01';
    //   const toDate = this.props.ToDate ? formatDate(this.props.ToDate) : '3000-01-01';
    //   if (this.props.Vendor) {
    //     const vendor = this.props.Vendor.value || this.props.Vendor;
    //     if (this.props.Year) {
    //       year = this.props.Year.value;
    //       if (this.props.Month) {
    //         if (this.props.Month.value < 10) {
    //             month += `0${this.props.Month.value}`;
    //         } else {
    //           month = this.props.Month.value;
    //         }
    //       }
    //       if (this.props.Quarter) {
    //         quarter = this.props.Quarter.value;
    //       }
    //       date = `${year}${month}${quarter}`;
    //       this.props.fetchVendorStatement(fromDate, toDate, vendor, nextProps.StatementType, date);
    //     } else {
    //       this.props.fetchVendorStatement(fromDate, toDate, vendor, nextProps.StatementType, date);
    //     }
    //   }
    // }
    if (nextProps.typeRadios && nextProps.typeRadios !== this.props.typeRadios) {
      this.resetDates();
    }

    // if (!this.props.typeRadios) {
    //   this.props.setDefaultOfForm('typeRadios', 'range', 'vendorStatement');
    //   this.props.setDefaultOfForm('FromDate', new Date('2017-08-18T00:00:00-0700'), 'vendorStatement');
    //   this.props.setDefaultOfForm('ToDate', new Date(), 'vendorStatement');
    // }
    // if (nextProps.Year && nextProps.Year !== this.props.Year) {
    //   this.setState({ yearChanged: !this.state.yearChanged });
    // }

    if (nextProps.Vendor && nextProps.Vendor !== this.props.Vendor) {
      this.props.fetchVendorDetail(nextProps.Vendor.value || nextProps.Vendor);
      // this.fetchVendorStatement(nextProps);
      const statementLines = [];
      const invoiceAmount = 0;
      const paymentAmount = 0;
      const totalBalance = 0;
      const remainingBalance = 0;
      const forwardedBalance = 0;
      this.setState({
        invoiceAmount,
        paymentAmount,
        totalBalance,
        remainingBalance,
        forwardedBalance,
        statementLines,
      });
      this.fetchVendorStatement(nextProps);
    }

    if (nextProps.apReport && nextProps.apReport !== this.props.apReport) {
      this.setState({ pdfFrameLoaded: false });
    }
    if (nextProps.warehouseReceivePdf && nextProps.warehouseReceivePdf !== this.props.warehouseReceivePdf) {
      this.setState({ pdfFrameWarehouseLoaded: false });
    }
    if (nextProps.selectedCompany !== this.props.selectedCompany) {
      this.props.fetchVendors(checkPermission('vendors_manager') ? {Company_id: undefined} : {});
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.pdfFrameLoaded !== this.state.pdfFrameLoaded && this.state.pdfFrameLoaded === false) {
      return false;
    }
    if (nextState.pdfFrameWarehouseLoaded !== this.state.pdfFrameWarehouseLoaded && this.state.pdfFrameWarehouseLoaded === false) {
      return false;
    }
    return true;
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  setToDate(e) {
    if (!this.props.Vendor) {
      alert('Please select a Vendor!');
      return;
    }
    if (e < this.state.fromDate) {
      return;
    }
    this.setState(
      { toDate: e },
      () => { this.props.fetchVendorStatement(this.state.fromDate, e, this.props.Vendor.value, this.props.StatementType, this.state.paymentCutoffDate); },
    );
  }

  setFromDate(e) {
    if (!this.props.Vendor) {
      alert('Please select a Vendor!');
      return;
    }
    if (e > this.state.toDate) {
      return;
    }
    this.setState(
      { fromDate: e },
      () => { this.props.fetchVendorStatement(e, this.state.toDate, this.props.Vendor.value, this.props.StatementType, this.state.paymentCutoffDate); },
    );
  }

  setMonthSelected(e) {
    if (!this.props.Vendor) {
      alert('Please select a Vendor!');
      return;
    }
    this.setState({ month: e.value }, this.formatFetchMonth);
  }

  setQuarterSelected(e) {
    if (!this.props.Vendor) {
      alert('Please select a Vendor!');
      return;
    }
    this.setState({ quarter: e.value }, this.formatFetchQuarter);
  }

  setPaymentCutoffDate(e) {
    if (!this.props.Vendor) {
      alert('Please select a Vendor!');
      return;
    }
    this.setState(
      { paymentCutoffDate: e },
      () => { this.props.fetchVendorStatement(this.state.fromDate, this.state.toDate, this.props.Vendor.value, this.props.StatementType, e); },
    );
  }

  getYearOptions() {
    const yearOptions = [];
    let year = (new Date().getFullYear() + 1);
    while (year > 2017) {
      year -= 1;
      yearOptions.push({ value: year, label: year });
    }
    return yearOptions;
  }

  getMonthOptions() {
    const { year } = this.state;
    const dateMap = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const monthOptions = [];
    const currentyear = new Date().getFullYear();
    let month = 0;
    if (year) {
      if (year < currentyear) {
        month = 12;
      } else {
        month = new Date().getMonth() + 1;
      }
      for (let i = 1; i < month + 1; i += 1) {
        monthOptions.push({ value: i, label: dateMap[i - 1] });
      }
    }
    return monthOptions;
  }

  getQuarterOptions() {
    const { year } = this.state;
    const quarterOptions = [];
    const currentyear = new Date().getFullYear();
    let quarter = 0;
    if (year) {
      if (year < currentyear) {
        quarter = 4;
      } else {
        const month = new Date().getMonth() + 1;
        quarter = (Math.ceil(month / 3));
      }
    }
    for (let i = 1; i < quarter + 1; i += 1) {
      quarterOptions.push({ value: i, label: i });
    }
    return quarterOptions;
  }

  getVendorNameOptions() {
    const vendorOptions = [];
    this.props.vendors.map((vendor) => {
      vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Name });
    });
    return vendorOptions;
  }

  getVendorNumOptions() {
    const vendorOptions = [];
    this.props.vendors.map((vendor) => {
      vendorOptions.push({ value: vendor.Vendor_id, label: vendor.VendorNum });
    });
    return vendorOptions;
  }

  getVendorPhoneOptions() {
    const vendorOptions = [];
    this.props.vendors.map((vendor) => {
      vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Telephone });
    });
    return vendorOptions;
  }

  getVendorDescriptionOptions() {
    const vendorOptions = [];
    this.props.vendors.map((vendor) => {
      vendorOptions.push({ value: vendor.Vendor_id, label: vendor.Description });
    });
    return vendorOptions;
  }

  getBillingAddress1() {
    const { currentVendorDetail } = this.props;
    if (currentVendorDetail && currentVendorDetail.Billing) {
      const Address1 = currentVendorDetail.Billing.Street;
      return Address1;
    }
    return '';
  }

  getBillingAddress2() {
    const { currentVendorDetail } = this.props;
    if (currentVendorDetail && currentVendorDetail.Billing) {
      const Address2 = `${currentVendorDetail.Billing.City} ${currentVendorDetail.Billing.State} ${currentVendorDetail.Billing.Zip}`;
      return Address2;
    }
    return '';
  }

  resetDates() {
    // this.props.setValue('vendorStatement', 'FromDate', '');
    // this.props.setValue('vendorStatement', 'ToDate', '');
    this.props.setValue('vendorStatement', 'Year', '');
    this.props.setValue('vendorStatement', 'Month', '');
    this.props.setValue('vendorStatement', 'Quarter', '');
  }

  handlePrintFrameOnLoad = () => {
    this.setState({ pdfFrameLoaded: true });
  }

  handlePrintFrameWarehouseOnLoad = () => {
    this.setState({ pdfFrameWarehouseLoaded: true });
  }

  handleResize = () => {
    this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.vendorsPage - 100 });
  }

  fetchVendorStatement = (props) => {
    const { Vendor, StatementType } = props;
    if (Vendor) {
      const vendor = Vendor.value || Vendor;
      //const { fromDate, toDate } = getFromToDatesWithFilter(props);
      this.props.fetchVendorStatement(this.state.fromDate, this.state.toDate, vendor, StatementType, this.state.paymentCutoffDate);
    }
  }

  formatFetchMonth() {
    const {
      year, month, typeRadios,
    } = this.state;
    let FromDate = moment([year, month - 1]);
    let ToDate = moment(FromDate).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, typeRadios,
    }, () => { this.props.fetchVendorStatement(FromDate, ToDate, this.props.Vendor.value, this.props.StatementType, this.state.paymentCutoffDate); });
  }

  formatFetchQuarter() {
    const {
      year, quarter, typeRadios,
    } = this.state;
    let FromDate = moment([year, (quarter - 1) * 3]);
    let ToDate = moment([year, (quarter * 3) - 1]).endOf('month');
    FromDate = FromDate.toISOString();
    ToDate = ToDate.toISOString();
    this.setState({
      fromDate: FromDate, toDate: ToDate, typeRadios,
    }, () => { this.props.fetchVendorStatement(FromDate, ToDate, this.props.Vendor.value, this.props.StatementType, this.state.paymentCutoffDate); });
  }

  handleDateFilterChange(type) {
    if (!this.props.Vendor) {
      alert('Please select a Vendor!');
      return;
    }
    if (type === 'month') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), month: new Date().getMonth() + 1 }, this.formatFetchMonth);
    } else if (type === 'quarter') {
      this.setState({ typeRadios: type, year: new Date().getFullYear(), quarter: VendorStatement.getQuarter() }, this.formatFetchQuarter);
    } else if (type === 'range' && type !== this.state.typeRadios) {
      this.setState({
        typeRadios: type, fromDate: (isOLG || isLAP) ? new Date(moment().subtract(7, 'd').toISOString()) : new Date('2017-08-18T00:00:00-0700'), toDate: new Date(),
      }, () => { this.props.fetchVendorStatement(this.state.fromDate, this.state.toDate, this.props.Vendor.value, this.props.StatementType); });
    }
  }

  handleTypeFilterChange = (event) => {
    const filter = event.target.value;
    const { statementLines } = this.state;
    let filteredLines;
    if (filter !== 'all') {
      filteredLines = statementLines.filter(line => line.type === filter);
    } else {
      filteredLines = statementLines;
    }
    this.setState({
      invoiceFilter: filter,
      filteredLines,
    });
  }

  renderDateSelector() {
    const yearOptions = this.getYearOptions();
    if (this.state.typeRadios === 'range') {
      return (
        <div>
          <div className="report-table-filters" id="vendor-statement-date-selector">
            <label className="from-label">
              <Translate value="from" />
            </label>
            {
              GenericDatePicker({
                ...(isOLG || isLAP) ? {id: 'cust_input1'} : {},
                setDate: this.setFromDate,
                selectedDate: this.state.fromDate,
              })
            }
            <label className="to-label">
              <Translate value="to" />
            </label>
            {
              GenericDatePicker({
                ...(isOLG || isLAP) ? {id: 'cust_input2'} : {},
                setDate: this.setToDate,
                selectedDate: this.state.toDate,
              })
            }
          </div>
        </div>
      );
    } else if (this.state.typeRadios === 'month') {
      const monthOptions = this.getMonthOptions();
      return (
        <Col xs={12}>
          <div className="report-table-filters" id="vendor-statement-date-selector">
            {
              GenericSelection({
                translation: <Translate value="year" />,
                options: yearOptions,
                value: this.state.year,
                setSelected: (e) => { this.setState({ year: e.value }); },
              })
            }
            {
              GenericSelection({
                translation: <Translate value="month" />,
                options: monthOptions,
                value: this.state.month,
                setSelected: this.setMonthSelected,
              })
            }
          </div>
        </Col>
      );
    }
    const quarterOptions = this.getQuarterOptions();
    return (
      <Col xs={12}>
        <div className="report-table-filters" id="vendor-statement-date-selector">
          {
            GenericSelection({
              translation: <Translate value="year" />,
              options: yearOptions,
              value: this.state.year,
              setSelected: (e) => { this.setState({ year: e.value }); },
            })
          }
          {
            GenericSelection({
              translation: <Translate value="quarter" />,
              options: quarterOptions,
              value: this.state.quarter,
              setSelected: this.setQuarterSelected,
            })
          }
        </div>
      </Col>
    );
  }

  renderVendorDetail() {
    const vendorNameOptions = this.getVendorNameOptions();
    const vendorNumOptions = this.getVendorNumOptions();
    const vendorPhoneOptions = this.getVendorPhoneOptions();
    const { currentVendorDetail } = this.props;
    let contact = null;
    let phone = null;
    if (currentVendorDetail && currentVendorDetail.Billing) {
      contact = `${currentVendorDetail.Billing.FirstName} ${currentVendorDetail.Billing.LastName}`;
      phone = currentVendorDetail.Billing.Telephone;
    }
    return (
      <Row>
        {/* Vendor Details */}
        <Col xs={4} id="vendor-details">
          <h4><Translate value="vendor_information" /></h4>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="name" /><span className="asteriksReq" >*</span> </label>
            <div id="vendor-name-dropdown" className="col-xs-8">
              <Field name="Vendor" component={Selection} matchPos="any" options={vendorNameOptions} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="vendor_no" /></label>
            <div id="vendor-id-dropdown" className="col-xs-8">
              <Field name="Vendor" component={Selection} matchPos="any" options={vendorNumOptions} />
            </div>
          </div>
          <div className="form-group">
            <label className="col-xs-3"><Translate value="phone" /></label>
            <div id="vendor-phone-dropdown" className="col-xs-8">
              <Field name="Vendor" component={Selection} matchPos="any" options={vendorPhoneOptions} />
            </div>
          </div>
        </Col>
        {/* Billing Information */}
        <Col xs={4} xsOffset={1} id="billing-info">
          <h4><Translate value="billing_information" /></h4>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="contact" />
            </label>
            <Col xs={9}>
              <Row>
                {
                  !this.props.currentVendorDetail &&
                  <Col xs={9}>
                    <Translate value="msg_please_select_a_vendor" />
                  </Col>
                }
                {this.props.currentVendorDetail && contact}
              </Row>
            </Col>
          </div>
          <div className="form-group">
            <label className="col-xs-3">
              <Translate value="phone" />
            </label>
            <Col xs={9}>
              <Row>
                {
                  !this.props.currentVendorDetail &&
                  <div className="col-xs-9">
                    <Translate value="" />
                  </div>
                }
                {this.props.currentVendorDetail && phone}
              </Row>
            </Col>
          </div>
          <div className="form-group mb0">
            <label className="col-xs-3">
              <Translate value="address" />
            </label>
            {
              this.props.currentVendorDetail &&
              <Col xs={9}>
                <Row>
                  {this.getBillingAddress1()}
                </Row>
                <Row>
                  {this.getBillingAddress2()}
                </Row>
              </Col>
            }
          </div>
        </Col> {/* End Billing Information */}
      </Row>
    );
  }

  renderAmountDetail() {
    const {
      invoiceAmount,
      paymentAmount,
      totalBalance,
      remainingBalance,
      forwardedBalance,
    } = this.state;
    // const { StatementType } = this.props;
    // const renderprevious = () => {
    //   if (StatementType === 'forwarded') {
    //     return (
    //       <RowLabelField
    //         translation='previous_balance_forward: '
    //         value={`$${previousBalance}`}
    //       />
    //     );
    //   }
    // };
    return (
      <Col xs={3}>
        {/* renderprevious() */}
        <RowLabelField
          translation="balance_forward:"
          value={`$${numberWithCommas(forwardedBalance)}` || 0}
          right={4}
        />
        <RowLabelField
          translation="total_invoice_amount:"
          value={`$${numberWithCommas(invoiceAmount)}` || 0}
          right={4}
        />
        <RowLabelField
          translation="total_payment:"
          value={`$${numberWithCommas(paymentAmount)}` || 0}
          right={4}
        />
        <RowLabelField
          translation="outstanding_balance:"
          value={`$${numberWithCommas(totalBalance)}` || 0}
          right={4}
        />
        <RowLabelField
          translation="remaining_balance:"
          value={`$${numberWithCommas(remainingBalance)}` || 0}
          right={4}
        />
      </Col>
    );
  }

  renderTable() {
    if (this.props.vendorStatementIsLoading && !this.props.vendorStatementError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } else if (this.props.vendorStatementError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">
            <Translate value="something_unexpected_happened" />
          </div>
        </ContentWrapper>
      );
    }
    const { statementLines } = this.state;
    return (
      <Row>
        <Col sm={12}>
          <div className="react-table-ar-ap-vendor-statement">
            <VendorStatementDetailTable
              printWarehouseReceive={this.props.printWarehouseReceive}
              rows={statementLines}
              minHeight={500}
            />
          </div>
        </Col>
      </Row>
    );
  }

  renderToolbarButtons() {
    const activeCompany = getLocalStorageData('selectedCompany')
    const { Vendor } = this.props;
    // const { fromDate, toDate } = getFromToDatesWithFilter(this.props);
    const { fromDate, toDate } = this.state;
    const dates = toFromDates(-1, fromDate, toDate);
    let vendor;
    if (Vendor) {
      vendor = Vendor.value || Vendor;
    }
    const paymentCutoffDate = getFromToDates(this.state.paymentCutoffDate).toDate;
    const token = localStorage.getItem('token');
    const apUrl = vendor
      ? `/AP/new?vend_id=${vendor}`
      : '/AP/new';
    let simplifiedExport = `${ROOT_URL}v1/ap/report/aged/${vendor}/simplifiedexcel/?start_date=${dates.fromDate}&end_date=${dates.toDate}&cut_off_date=${paymentCutoffDate}&Bearer=${token}`;
    let detailedExport = `${ROOT_URL}v1/ap/report/aged/${vendor}/excel/?start_date=${dates.fromDate}&end_date=${dates.toDate}&cut_off_date=${paymentCutoffDate}&Bearer=${token}`;
    return (
      <ButtonToolbar>
        <Button
          bsStyle="success"
          type="button"
          href={apUrl}
          disabled={!checkPermission('change_account_payable')}
        >
          <em className="fa fa-plus" />
          <Translate value="create_ap" />
        </Button>
        <Button
          bsStyle="success"
          type="button"
          href={simplifiedExport}
          disabled={!vendor || !checkPermission('print_vendor_statement')}
        >
          <em className="fa fa-download" />
          <Translate value="simplified_excel" />
        </Button>
        <Button
          bsStyle="success"
          type="button"
          href={detailedExport}
          disabled={!vendor || !checkPermission('print_vendor_statement')}
        >
          <em className="fa fa-download" />
          <Translate value="detailed_excel" />
        </Button>
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printAPReport(vendor, dates.fromDate, dates.toDate, paymentCutoffDate, true, activeCompany);
          }}
          disabled={!vendor || !checkPermission('print_vendor_statement')}
        >
          <em className="fa fa-print" />
          <Translate value="simplified_statement" />
        </Button>
        <Button
          bsStyle="primary"
          type="button"
          onClick={() => {
            this.props.printAPReport(vendor, dates.fromDate, dates.toDate, paymentCutoffDate, false, activeCompany);
          }}
          disabled={!vendor || !checkPermission('print_vendor_statement')}
        >
          <em className="fa fa-print" />
          <Translate value="detailed_statement" />
        </Button>
        <Button
          bsStyle="danger"
          type="button"
          onClick={() => { this.props.router.push('/vendorStatementMain'); }}
        >
          <Translate value="back" />
        </Button>
      </ButtonToolbar>
    );
  }

  renderPrintIframe() {
    const { pdfFrameLoaded } = this.state;
    const { apReport } = this.props;
    return (
      <PrintIframe
        id="vendorStatementPDF"
        loaded={pdfFrameLoaded}
        name="vendorStatementPDF"
        onLoad={this.handlePrintFrameOnLoad}
        pdf={apReport}
        title={<Translate value="ap_report" />}
      />
    );
  }

  renderPrintWarehouseIframe() {
    const { pdfFrameWarehouseLoaded } = this.state;
    const { warehouseReceivePdf } = this.props;
    return (
      <PrintIframe
        id="warehousePDF"
        loaded={pdfFrameWarehouseLoaded}
        name="warehousePDF"
        onLoad={this.handlePrintFrameWarehouseOnLoad}
        pdf={warehouseReceivePdf}
        title={<Translate value="warehouse_print" />}
      />
    );
  }

  render() {
    if(isOLG || isLAP) {
      let rangeInput1 = document.getElementById('cust_input1_input');
      let rangeInput2 = document.getElementById('cust_input2_input');
      let rangeInput3 = document.getElementById('cust_input3_input');
      let span1 = document.querySelector('#cust_input1 .rw-select .rw-btn');
      let span2 = document.querySelector('#cust_input2 .rw-select .rw-btn');
      let span3 = document.querySelector('#cust_input3 .rw-select .rw-btn');
      if(rangeInput1) {
        rangeInput1.disabled = true;
      }
      if(rangeInput2) {
        rangeInput2.disabled = true;
      }
      if(rangeInput3) {
        rangeInput3.disabled = true;
      }
      if(span1) {
        span1.style.background = 'white'
      }
      if(span2) {
        span2.style.background = 'white'
      }
      if(span3) {
        span3.style.background = 'white'
      }
    }
    return (
      <ContentWrapper>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="ar_slashsign_ap" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="vendor_statement" />
          </Breadcrumb.Item>
        </Breadcrumb>

        { this.renderToolbarButtons() }

        <Grid id="vendor-statement">
          {/* Date Range Pickers */}
          <Col xs={12}>
            <fieldset className="form-horizontal">
              <Panel id="vendor-statement-vendor-info">
                {this.renderVendorDetail()}
              </Panel>
            </fieldset>
          </Col>
          <Col xs={12}>
            <Panel id="date-range-picker" className="form-horizontal">
              <Row>
                <Col xs={1} id="filter-title-center">
                  <h3 className="text-right"><Translate value="statement_range" /><span className="colon">:</span></h3>
                </Col>
                <Col xs={4}>
                  <div id="status-filter-radios">
                    {
                      genericRadioFilter({
                        content: [
                          {
                              option: 'range',
                              id: 'dateRange-radio-filter',
                              name: 'dateFilterRadios',
                              labelName: 'date_range',
                          },
                          {
                              option: 'quarter',
                              id: 'quarter-radio-filter',
                              name: 'dateFilterRadios',
                              labelName: 'quarter',
                          },
                          {
                              option: 'month',
                              id: 'month-radio-filter',
                              name: 'dateFilterRadios',
                              labelName: 'month',
                          },
                        ],
                        value: this.state.typeRadios,
                        handleOnClick: this.handleDateFilterChange,
                        type: 'buttons',
                      })
                    }
                  </div>
                  {this.renderDateSelector()}
                </Col>
                <Col xs={1} id="filter-title-center">
                  <h3 className="text-right"><Translate value="payment_cutoff_date" /><span className="colon">:</span></h3>
                </Col>
                <Col xs={2} id="status-filter-radios">
                  <div>
                    {
                      GenericDatePicker({
                        ...(isOLG || isLAP) ? {id: 'cust_input3'} : {},
                        setDate: this.setPaymentCutoffDate,
                        selectedDate: this.state.paymentCutoffDate,
                      })
                    }
                  </div>
                  <p style={{position: "relative", left: "5px", top: "3px"}}>(<Translate value="simplified_statement_only" />)</p>
                </Col>
                {this.renderAmountDetail()}
              </Row>
            </Panel>
            <Row>
              <Col xs={12}>
                <Panel className="position-relative table-collapse-fix mb0">
                  {/* Render Inventory Table  */}
                  { this.renderTable() }
                </Panel>
              </Col>
            </Row>
          </Col>
        </Grid>
        { this.renderPrintIframe() }
        { this.renderPrintWarehouseIframe() }
      </ContentWrapper>
    );
  }
}

export default VendorStatement;



// WEBPACK FOOTER //
// ./master/jsx/components/AP/vendorStatement.jsx